import React, { useState } from 'react'

function CreateArea({ onAdd }) {

    const [expanded, setExpanded] = useState(false)

    const [note, setNote] = useState({
        title: '',
        content: '',
        num: Math.random() * 1000,
    })

    const handleChange = (e) => {
        // console.log(e.target)
        const { name, value } = e.target;

        setNote({ ...note, [name]: value })
    }

    const handleSubmit = (e) => {
        onAdd(note)
        setNote({
            title: '',
            content: '',

        })
        e.preventDefault();
    }

    const handleExpanded = (event) => {
        setExpanded(true);
    }




    return (
        <div className='crarea'>
            <form >
                {
                    expanded && (
                        <input value={note.title} onChange={handleChange} type="text" placeholder='Title' name="title" id="" autoComplete="off" />
                    )
                }
                <p>
                    <textarea rows={expanded ? 3 : 1} onClick={handleExpanded} value={note.content} onChange={handleChange} name="content" placeholder='Take a note ...'></textarea>
                </p>
                <button disabled={!note.title && !note.content} onClick={handleSubmit}>
                    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="35" width="35" xmlns="http://www.w3.org/2000/svg"><path d="M368.5 240H272v-96.5c0-8.8-7.2-16-16-16s-16 7.2-16 16V240h-96.5c-8.8 0-16 7.2-16 16 0 4.4 1.8 8.4 4.7 11.3 2.9 2.9 6.9 4.7 11.3 4.7H240v96.5c0 4.4 1.8 8.4 4.7 11.3 2.9 2.9 6.9 4.7 11.3 4.7 8.8 0 16-7.2 16-16V272h96.5c8.8 0 16-7.2 16-16s-7.2-16-16-16z"></path></svg>
                </button>
            </form>
        </div>
    )
}

export default CreateArea
